export const formatCpf = (value: string): string =>
    value.replace(/\D/g, '').replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');

export const formatCnpj = (value: string): string =>
    value.replace(/\D/g, '').replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');

export const formatDocument = (value?: string): string => {
    if (!value) return '';
    const digits = value.replace(/\D/g, '');
    return digits.length === 14 ? formatCnpj(digits) : formatCpf(digits);
};
